import { Component, HostBinding, OnInit } from '@angular/core';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { GlobalDataService } from "./shared-services/global-data.service";
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    @HostBinding('class') hostingClass;
    title = 'Culture App';
    isDev = !environment.production && (sessionStorage.getItem("underConstruction") === null || sessionStorage.getItem("underConstruction") === "1");

    //isDev = false;

    constructor(private router: Router, private translate: TranslateService, private globalDataService: GlobalDataService) {
        translate.setDefaultLang('en');
        translate.use('en');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (evt instanceof RoutesRecognized) {
                let route = evt.state.root.firstChild;
                this.hostingClass = 'page-' + route.data.domain;
                this.globalDataService.domain = route.data.domain;
            }
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
        let everyPay = document.createElement("script");
        everyPay.type = "text/javascript";
        everyPay.src = environment.everypay.script;
        document.getElementsByTagName('head')[0].appendChild(everyPay);
    }

    clickToEnter(element) {
        if (element.value === 'culturevr@2021!') {
            sessionStorage.setItem("underConstruction", "0");
            this.isDev = false;
        }
    }
}
